import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type EmissionsWithLabelClasses = 'emissionLabel' | 'emission' | 'infoIcon';

const EmissionsWithLabelStyles = makeStyles<ISpcTheme, EmissionsWithLabelClasses>(theme => ({
  emissionLabel: {
    color: theme.palette.text.primary,
    lineHeight: '18px',
  },
  emission: {
    color: theme.palette.secondary.main,
    fontWeight: 700,
    lineHeight: '24px',
    paddingRight: '6px',
    textTransform: 'none',
  },
  infoIcon: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.fontLG,
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.fontMD,
    },
  },
}));

export default EmissionsWithLabelStyles;
